module.exports = __webpack_public_path__ + "img/logo_nextgen.d7dea025.png";